import React from "react";

import ButtonInput from "../../../../components/common/Button/ButtonInput";
import CustomDatePicker from "../../../../components/common/DatePicker/CustomDatePicker";
import CustomTable from "../../../../components/common/Table/CustomTable";
import TextInput from "../../../../components/common/TextInput/TextInput";

import { renderImmediateTopupColumns } from "../constants";

const ImmediateTopup = ({
  handleSendTopupButtonClick,
  handleCancelTopupButtonClick,
  data,
  loading,
  handleTableChange,
  tablePagination,
  handleEnter,
  pageSizeValue,
  handleOutletButtonClick,
  handleDateChange,
  handleInputChange,
  dateValue,
}) => {
  return (
    <div className="py-3">
      <div className="d-flex filter-bar filter-bar-2">
        <TextInput
          id={"pageSize"}
          label={"Tampilkan"}
          width={"7%"}
          handleEnter={handleEnter}
          value={pageSizeValue}
          handleChange={handleInputChange}
        />
        <ButtonInput
          id={"outlet"}
          label={"Cabang/Outlet"}
          buttonText={"Nama Cabang"}
          onButtonClick={handleOutletButtonClick}
          variant={"outline-secondary"}
          width={"13%"}
        />
        <CustomDatePicker
          id={"immediateTopup"}
          label={"Tanggal Permohonan"}
          isRangePicker
          width="20%"
          onInputChange={handleDateChange}
          value={dateValue}
        />
      </div>

      <CustomTable
        columns={renderImmediateTopupColumns(
          handleSendTopupButtonClick,
          handleCancelTopupButtonClick
        )}
        data={data}
        loading={loading}
        handleTableChange={handleTableChange}
        pagination={tablePagination}
      />
    </div>
  );
};

export default ImmediateTopup;
